// extracted by mini-css-extract-plugin
export default {"editorHolder":"TinyEditor_editorHolder__1x701","editorHeader":"TinyEditor_editorHeader__BLaon"};